import { Fragment, useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import PageHeader from "../component/layout/pageheader";

import { ShopContext } from "../context/ShopContext";

const UserProfile = () => {
  const { backendUrl, token } = useContext(ShopContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  /* Fetch current user info */
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `${backendUrl}/api/user/profile`,
          { headers: { token } }
        );

        if (res.data.success) {
          setName(res.data.user.name || "");
          setEmail(res.data.user.email);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchProfile();
  }, [backendUrl, token]);

  /* Update name + email */
  const updateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        `${backendUrl}/api/user/profile`,
        { name, email },
        { headers: { token } }
      );

      if (res.data.success) {
        toast.success("Profile updated");
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  /* Update password */
  const updatePassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        `${backendUrl}/api/user/password`,
        { currentPassword, newPassword },
        { headers: { token } }
      );

      if (res.data.success) {
        toast.success("Password updated");
        setCurrentPassword("");
        setNewPassword("");
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Header />
      <PageHeader title="Account Settings" curPage="Profile" />

      <div className="profile-page padding-top padding-bottom">
        <div className="container">

          <div className="profile-card">

            {/* ===== HEADER ===== */}
            <div className="profile-header">
              <div className="profile-avatar">
                {email?.charAt(0).toUpperCase()}
              </div>
              <div className="profile-meta">
                <h4>{name || "Your Account"}</h4>
                <p>{email}</p>
              </div>
            </div>



            {/* ===== ACCOUNT DETAILS ===== */}
            <form className="profile-section" onSubmit={updateProfile}>
              <h5 className="section-title">Account Details</h5>

              <div className="profile-grid">
                <div className="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    placeholder="Optional"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="default-button"
                disabled={loading}
              >
                <span>{loading ? "Saving..." : "Save Changes"}</span>
              </button>
            </form>

            {/* ===== SECURITY ===== */}
            <form className="profile-section mt-5" onSubmit={updatePassword}>
              <h5 className="section-title">Security</h5>

              <div className="profile-grid">
                <div className="form-group">
                  <label>Current Password</label>
                  <input
                    type="password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="default-button"
                disabled={loading}
              >
                <span>{loading ? "Updating..." : "Update Password"}</span>
              </button>
            </form>

          </div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default UserProfile;
